import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../_virtual/_rollupPluginBabelHelpers.js';
import styled from 'styled-components';
import { getArrowPosition } from './Tooltip.helpers.js';
import { getTypographyStyles } from '../Typography/Typography.styles.js';

var _templateObject, _templateObject2, _templateObject3;
var TooltipWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  width: fit-content;\n"])));
var TooltipContainer = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  background: ", ";\n  color: ", ";\n  padding: ", ";\n\n  ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colours.graphics.primary.main;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colours.graphics.primary.ink;
}, function (_ref3) {
  var $isCondensed = _ref3.$isCondensed,
    sizing = _ref3.theme.sizing;
  return $isCondensed ? "".concat(sizing.tiny, " ").concat(sizing.small) : sizing.small;
}, function (_ref4) {
  var theme = _ref4.theme,
    $placement = _ref4.$placement;
  return getArrowPosition(theme, $placement);
});
var TooltipContent = styled(getTypographyStyles('bodyMedium'))(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  color: ", ";\n"])), function (_ref5) {
  var theme = _ref5.theme;
  return theme.colours.graphics.primary.ink;
});

export { TooltipContainer, TooltipContent, TooltipWrapper };
//# sourceMappingURL=Tooltip.styles.js.map
